<template>
  <v-navigation-drawer
    permanent
    class="elevation-0"
    :class="$style['navigation-drawer']"
    :mini-variant="collapsed"
  >
    <v-list dense nav>
      <v-list-item
        v-for="item in items"
        :key="item.index"
        dense
        :input-value="isActive(item.index)"
        @click="onClickMenu(item.index)"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  data() {
    return {
      title: this.$config.title,
      items: [
        {
          index: "recipes",
          icon: "mdi-card-text-outline",
          text: "レシピ管理"
        },
        {
          index: "logout",
          icon: "mdi-logout-variant",
          text: "ログアウト"
        }
      ]
    };
  },
  computed: {
    collapsed() {
      return this.$store.getters["toolbar/sideMenuCollapsed"];
    },
    role() {
      return this.$store.getters["auth/role"];
    }
  },
  methods: {
    onClickMenu(index) {
      if (index === "logout") {
        this.$store.dispatch("auth/logout");
      } else {
        this.$router.push({ name: index }, () => {});
      }
    },
    isActive(index) {
      return this.$route.path.split("/")[1] === index;
    }
  }
};
</script>

<style module lang="scss">
.navigation-drawer {
  z-index: 3 !important;

  .navigation-drawer-header {
    height: 50px;
  }
}
</style>

<style lang="scss">
  .v-list-item__title{
    font-size: 15px !important;
  }
</style>
